import React from "react";
import styled from "styled-components";
import * as moment from "moment";
import { convertedDivPrice } from '../../../config/common';

const Root = styled.div`
  margin-top: 50px;
`;
const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

// const Root = styled.div`
//   padding-bottom: ${(p) => p.theme.spacing.sm};
//   margin-bottom:60px;
// `;
// const Container = styled.div`
// width:80%;
// margin:0 auto;
// @media(max-width:${(p) => p.theme.screen.lg}){
//   width:90%;
// }
// @media(max-width:${(p) => p.theme.screen.md}){
//   width:calc(100% - 40px);
// }
// `;

const Wrapper = styled.div`
  /* background: linear-gradient(
    180deg,
    rgba(249, 249, 249, 0.04) 0%,
    rgba(249, 249, 249, 0.04) 100%
  );
  border-width: 1px 0px;
  border-style: solid;
  border-color: rgba(255, 255, 255, 0.4);
  box-shadow: 0px 19px 46px rgba(0, 0, 0, 0.12);
  border-radius: 30px; */
  width: 80%;
  @media (max-width: 1024px) {
    width: 100%;
  }
  @media (max-width: 768px) {
    overflow-x: scroll;
    width: 100%;
  }
`;

const TextWrapper = styled.div`
  padding: 20px 30px;
  @media (max-width: 768px) {
    padding: 20px 0px;
  }
  @media (max-width: 1024px) {
    padding: 20px 0px;
  }
`;
const Text = styled.text`
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 19px;
  color: #ffffff;
`;

const TableWrapper = styled.div`
  margin: 30px 0;
`;
const HeadingWrapper = styled.div`
  display: grid;
  grid-template-columns: 50% 20% 30%;
  justify-content: center;
  align-items: center;
  text-align: start;
  padding: 6px 20px;
  background-color: #181d21;
  border-radius: 8px;
  @media(max-width:768px){
width: 800px;
overflow-x:scroll;
}
  
`;
const HeadingText = styled.text``;
const TableContentWrapper = styled.div`
  display: grid;
  grid-template-columns: 50% 20% 20%;
  margin: 20px 0;
  background: linear-gradient(
    180deg,
    rgba(249, 249, 249, 0.016) 0%,
    rgba(255, 255, 255, 0.072) 100%,
    rgba(249, 249, 249, 0.016) 100%
  );
  border-radius: 30px;
  padding: 10px 20px;
`;
const TableValueImageWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
`;
const Imagewrapper = styled.div`
  margin-right: 10px;
`;
const Image = styled.img``;
const TableContent = styled.div``;

const TableTextWrapper = styled(TextWrapper)`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  text-align: start;
  width: 80%;
  @media (max-width: 768px) {
    width: 100%;
    padding: 0px 20px;
  }
  @media (max-width: 1024px) {
    width: 100%;
    padding: 0px 20px;
  }
`;

const BidingHistoryContainer = styled(Container)`
  margin-top: 20px;
`;

const HistoryWrapper = ({ tradeList, bidList, data }) => {
  
  const checkIsUSDT = (address) => {
    if (address === "0xca082498a1dE55c5d13C5AF2B10CA5e1957349E6") {
      return true;
    } else {
      return false;
    }
  };

  const convertedPrice = (currency, price) => {
    return checkIsUSDT(currency)
      ? Number(price) / 1000000
      : Number(price) / 1000000000000000000;
  };

  const getTradeCurrency = (id) => {
    let answer = "";

    if (id === "0xca082498a1dE55c5d13C5AF2B10CA5e1957349E6") {
      answer = "USDT";
    }
    if (id === "0xc2132D05D31c914a87C6611C10748AEb04B58e8F") {
      answer = "MLD";
    }
    if (id === "0x0000000000000000000000000000000000001010") {
      answer = "MATIC";
    }

    return answer;
  };

  const toDate = (number) => {
    // console.log('new Date(number)', new Date(number))
    return moment(new Date(number)).format("DD/MM/YYYY HH:mm:ss")
  }
  return (
    <Root>
      {/* <Container>
        <TableTextWrapper>
          <Text>Activity and History for This Item </Text>
        </TableTextWrapper>
        <Wrapper>
          <TextWrapper>
            <TableWrapper>
              <HeadingWrapper>
             
                <HeadingText>Price</HeadingText>
                <HeadingText>Trending Currency </HeadingText>
                <HeadingText>Time </HeadingText>
              </HeadingWrapper>
              {tradeList?.length > 0 &&
                tradeList.map((trade, i) => {
                  return (
                    <TableContentWrapper key={i}>
                   
                      <TableContent>
                        {convertedDivPrice(trade?.args?.["currency"], trade?.args?.["price"]) || "-"}
                      </TableContent>
                      <TableContent>
                        {getTradeCurrency(trade?.args?.["currency"]) || "-"}{" "}
                      </TableContent>
                     
                      <TableContent>
                        {trade?.args?.["timestamp"] ? toDate(Number(trade?.args?.["timestamp"]) * 1000) : "-"}{" "}
                      </TableContent>
                    </TableContentWrapper>
                  );
                })}
              
            </TableWrapper>
          </TextWrapper>
        </Wrapper>
      </Container> */}

      <BidingHistoryContainer>
        <TableTextWrapper>
          <Text>Table Biding History </Text>
        </TableTextWrapper>
        <Wrapper>
          <TextWrapper>
            <TableWrapper>
              <HeadingWrapper>
                <HeadingText>Address</HeadingText>
                <HeadingText>Amount</HeadingText>
                <HeadingText>Time </HeadingText>
              </HeadingWrapper>
              {bidList?.length > 0 &&
                bidList.map((bid, i) => {
                  return (
                    <TableContentWrapper key={i}>
                      <TableValueImageWrapper>
                        <TableContent>
                          {bid?.args?.["bidder"] || "-"}
                        </TableContent>
                      </TableValueImageWrapper>
                      <TableContent>

                        {convertedDivPrice(data?.tradeCurrency, bid?.args?.["bidAmount"]) || "-"}
                      </TableContent>
                      <TableContent>
                        {bid?.args?.["biddingTime"] ? toDate(Number(bid?.args?.["biddingTime"]) * 1000) : "-"}{" "}
                      </TableContent>
                    </TableContentWrapper>
                  );
                })}
            
            </TableWrapper>
          </TextWrapper>
        </Wrapper>
      </BidingHistoryContainer>
    </Root>
  );
};

export default HistoryWrapper;
